import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CalendarModule } from 'angular-calendar';
import { MaterialModule } from '@app/material';
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import {
  MinValueValidatorDirective,
  NumbersOnly,
  PermissionsDirective,
  RolesDirective,
} from './directives';

import {
  NavItemComponent,
  NavMenuComponent,
  RequestFilesComponent,
  RequestStatusHistoryComponent,
  ToolbarComponent,
  UserLookupComponent,
  RequestApproveFormComponent,
  RequestRejectFormComponent,
  RequestCancelFormComponent,
  RequestChargeComponent,
  MeetingCalendarComponent,
  SharedGetValueFormComponent,
  RequestFeedbackFormComponent,
  RequestFeedbackListComponent
} from './components';

import { HomeComponent } from './containers/home/home.component';
import { LandingComponent } from './landing/landing.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ProfileViewComponent } from './profile-view/profile-view.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { BuildingUnitFilterPipe } from './pipes/building-unit-filter.pipe';
import { BuildingLevelFilterPipe } from './pipes/building-level-filter.pipe';
import { DataLoaders } from './loaders';




@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
   
  ],
  exports: [
    // Modules
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,

    // Components
    ErrorPageComponent,
    UserLookupComponent,
    RequestStatusHistoryComponent,
    RequestFilesComponent,
    RequestChargeComponent,
    RequestApproveFormComponent,
    RequestRejectFormComponent,
    RequestCancelFormComponent,
    MeetingCalendarComponent,
    SharedGetValueFormComponent,
    RequestFeedbackFormComponent,
    RequestFeedbackListComponent,

    // Directives
    NumbersOnly,
    PermissionsDirective,
    RolesDirective,
    MinValueValidatorDirective,

    // Pipes
    BuildingUnitFilterPipe,
    BuildingLevelFilterPipe,

  ],
  declarations: [
    HomeComponent,
    LandingComponent,
    PageNotFoundComponent,
    ContactUsComponent,
    NavItemComponent,
    NavMenuComponent,
    ProfileViewComponent,
    ConfirmDialogComponent,
    ToolbarComponent,
    ErrorPageComponent,
    BuildingUnitFilterPipe,
    BuildingLevelFilterPipe,
    UserLookupComponent,
    RequestStatusHistoryComponent,
    RequestChargeComponent,
    MeetingCalendarComponent,
    // Directives
    NumbersOnly,
    PermissionsDirective,
    RolesDirective,
    MinValueValidatorDirective,
    RequestFilesComponent,
    RequestRejectFormComponent,
    RequestApproveFormComponent,
    RequestCancelFormComponent,
    SharedGetValueFormComponent,
    RequestFeedbackFormComponent,
    RequestFeedbackListComponent,

  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: '6Le9m7gUAAAAAJUgtqEucGCiMMaEksmC1eJYW7OK' } as RecaptchaSettings,
    },
    DataLoaders,
  ],
  entryComponents: [ConfirmDialogComponent, UserLookupComponent]

})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts